import { Component, OnInit } from '@angular/core';
import { RouteService } from '@services/route.service';

@Component({
  selector: 'gob-shipper-page',
  templateUrl: './shipper-page.component.html',
  styleUrls: ['./shipper-page.component.css']
})
export class ShipperPageComponent implements OnInit {

  constructor(public route: RouteService) { }

  ngOnInit(): void {
  }

}
